import React from "react";
import { Modal, Pressable, Text } from "react-native";
import { View } from "ui/atoms/view";
import { CloseIcon, Icon } from "ui/gluestack/icon";

export interface Props {
  isVisible: boolean;
  onClose: () => void;
  title?: string;
  children?: React.ReactNode;
  noBackgroundClose?: boolean;
}

export function FloorPlanModalLayout({
  isVisible,
  onClose,
  title,
  children,
  noBackgroundClose,
}: Props) {
  return (
    <Modal
      visible={isVisible}
      onRequestClose={onClose}
      transparent
      animationType="fade"
    >
      <View className="p-5 flex-1 bg-black/50 items-center justify-center relative">
        {!noBackgroundClose ? (
          <Pressable
            onPress={onClose}
            className="absolute top-0 left-0 bottom-0 right-0"
          />
        ) : null}
        <View
          className={`rounded-xl bg-white drop-shadow-xl w-full max-w-[848px] lg:w-[848px] mx-auto max-h-[90vh] lg:h-[848px]`}
        >
          <View>
            <View className="flex flex-row justify-between items-center border-b border-border-200 py-5 px-10">
              <Text className="text-gray-700 font-semibold text-lg">
                {title}
              </Text>

              <Pressable onPress={onClose}>
                <Icon as={CloseIcon} size="md" />
              </Pressable>
            </View>
          </View>
          <View className="flex-1">{children}</View>
        </View>
      </View>
    </Modal>
  );
}
